import { Validator } from "vee-validate";
import pt_BR from "vee-validate/dist/locale/pt_BR";

export default () => {
  Validator.localize("br", pt_BR);
};
